/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import {
    GET_SCOPES,
    FETCH_SCOPES_SUCCESS,
    FETCH_SCOPES_FAILURE,
    POLL_SCOPES_START,
    POLL_SCOPES_STOP,
    ADDED_SCOPES,
    DELETE_SCOPES,
	UPDATE_SCOPES,
} from './actionTypes'
import { Scopes } from './scopes'

//Get Scopes
export function getScopes(agentId) {
	return dispatch => {
	return Scopes.getScopes({agentId:agentId})
    .then(response => response.data)
    .then(json => dispatch(fetchScopesSuccess(json)))
    .catch(function (error) {
      dispatch(fetchScopesFailure(error))
    })
	}
}

export function getScopeById() {
    return {
        type: GET_SCOPES,
    }
}

export function fetchScopesSuccess(json) {
    return {
        type: FETCH_SCOPES_SUCCESS,
        scopes: json
    }
}

export function fetchScopesFailure(error) {
    return {
        type: FETCH_SCOPES_FAILURE,
        errorMessage: error.message
    }
}

export function pollScopesStart(agentId) {
    return {
        type: POLL_SCOPES_START,
        agentId:agentId
    }
}

export function pollScopesStop() {
    return {
        type: POLL_SCOPES_STOP
    }
}
export function deleteScopes(deletedItem) {
	  return {
	    type:DELETE_SCOPES,
	    deletedScopes: deletedItem
	  }
	}
export function updateScopes(updatedItem) {
	  return {
	    type:UPDATE_SCOPES,
	    updatedScopes: updatedItem
	  }
	}
export function addScopes(addedItem) {
	  return {
	    type:ADDED_SCOPES,
	    addedScopes: addedItem
	  }
	}